'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var themes = require('@wow/themes');

const {
  textStyles: {
    labelSm
  },
  colors: {
    neutral
  }
} = themes.themeChakra;
const baseStyle = {
  container: {
    '& [data-disabled] + .chakra-input__group + .chakra-form__helper-text': {
      opacity: 0.4
    },
    '& [data-disabled] + .chakra-form__helper-text': {
      opacity: 0.4
    },
    '& [data-disabled] + .chakra-input__group + .chakra-form__error-message': {
      opacity: 0.4
    },
    '& [data-disabled] + .chakra-form__error-message': {
      opacity: 0.4
    },
    '& [disabled] + .chakra-form__helper-text': {
      opacity: 0.4
    },
    '& [disabled] + .chakra-form__error-message': {
      opacity: 0.4
    }
  },
  helperText: Object.assign(Object.assign({}, labelSm), {
    color: neutral[90],
    marginTop: '0px !important'
  })
};
const FormChakra = {
  baseStyle
};

exports.FormChakra = FormChakra;
